import { swapArrayElements } from "../helpers/common-methods";
export class GridService {
    constructor(map) {
        this.map = map;
        this.grid = {};
        this.resetGrid();
    }
    getNeighbors(object) {
        const output = new Set();
        object.relatedCells.forEach(index => {
            this.grid[index].forEach(o => {
                if (o !== object)
                    output.add(o);
            });
        });
        return Array.from(output);
    }
    updateObjectPosition(o) {
        this.removeObjectFromGrid(o);
        this.addObjectToGrid(o);
    }
    // TODO: Check if it faster not remove/add all items, but update only changed items
    removeObjectFromGrid(object) {
        object.relatedCells.forEach(index => {
            for (let [i, obj] of this.grid[index].entries()) {
                if (obj === object) {
                    // Swap our object with the last item in array and then remove last item (performance hack)
                    swapArrayElements(this.grid[index], i, this.grid[index].length - 1);
                    this.grid[index].pop();
                    break;
                }
            }
        });
        object.relatedCells = [];
    }
    addObjectToGrid(object) {
        const relatedCells = this.getRelatedCells(object.coords, object.size);
        relatedCells.forEach(index => this.grid[index].push(object));
        object.relatedCells = relatedCells;
    }
    resetGrid() {
        const cells = this.getRelatedCells([0, 0], [this.map.width, this.map.height]);
        cells.forEach(index => this.grid[index] = []);
    }
    getRelatedCells(coords, size) {
        const topLeftCorner = this.getCellCoords(coords);
        const bottomRightCorner = this.getCellCoords([coords[0] + size[0], coords[1] + size[1]]);
        const output = [];
        for (let x = topLeftCorner[0]; x <= bottomRightCorner[0]; x++) {
            for (let y = topLeftCorner[1]; y <= bottomRightCorner[1]; y++) {
                output.push(this.getCellIndex([x, y]));
            }
        }
        return output;
    }
    getCellCoords(objCoords) {
        const x = Math.floor(objCoords[0] / this.map.cells.size);
        const y = Math.floor(objCoords[1] / this.map.cells.size);
        return [x, y];
    }
    getCellIndex(cellCoords) {
        return cellCoords[0] + 'x' + cellCoords[1];
    }
}
